var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.7V5.3C18 3.61984 18 2.77976 17.673 2.13803C17.3854 1.57354 16.9265 1.1146 16.362 0.82698C15.7202 0.5 14.8802 0.5 13.2 0.5H5.8C4.11984 0.5 3.27976 0.5 2.63803 0.82698C2.07354 1.1146 1.6146 1.57354 1.32698 2.13803C1 2.77976 1 3.61984 1 5.3V12.7C1 14.3802 1 15.2202 1.32698 15.862C1.6146 16.4265 2.07354 16.8854 2.63803 17.173C3.27976 17.5 4.11984 17.5 5.8 17.5H13.2C14.8802 17.5 15.7202 17.5 16.362 17.173C16.9265 16.8854 17.3854 16.4265 17.673 15.862C18 15.2202 18 14.3802 18 12.7Z",
    stroke: "black",
    strokeOpacity: 0.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheckBox);
export default __webpack_public_path__ + "static/media/white-check-box.f6bf942d2c2c465dae074c22fd5d0c22.svg";
export { ForwardRef as ReactComponent };